export const WAITING_REVIEW = 'quote_pending_retailer_review';
export const REVIEW_IN_PROGRESS = 'review_in_progress';
export const WAITING_CUSTOMER = 'quote_pending_customer_review';
export const UPDATING_QUOTE = 'quote_processing_by_eshop';
export const ACCEPTED = 'quote_accepted';
export const CANCELLED = 'quote_cancelled';
export const REFUSED = 'quote_refused';
export const EXPIRED = 'quote_expired';
